<template>
    <div class="dashboard">

        <!-- Charts -->
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="24" class="mb-24">

                <table>
                    <tbody>
                    <tr>
                        <td style="min-width: 150px; font-weight: bold">Nama Mahasiswa</td>
                        <td style="padding-right: 5px">:</td>
                        <td>{{ this.is_partner ? this.booking.koas_resident_name2 : this.booking.koas_resident_name }}</td>
                    </tr>
                    <tr>
                        <td style="min-width: 150px; font-weight: bold">Hari / Tanggal</td>
                        <td style="padding-right: 5px">:</td>
                        <td>{{ this.formatDate(this.booking.booking_date) }}</td>
                    </tr>
                    <tr>
                        <td style="min-width: 150px; font-weight: bold">Kasus</td>
                        <td style="padding-right: 5px">:</td>
                        <td>{{ this.case }}</td>
                    </tr>
                    <tr>
                        <td style="min-width: 150px; font-weight: bold">Nama Pasien</td>
                        <td style="padding-right: 5px">:</td>
                        <td>{{ this.booking.patient_name }}</td>
                    </tr>
                    <tr>
                        <td style="min-width: 150px; font-weight: bold">No DU</td>
                        <td style="padding-right: 5px">:</td>
                        <td>{{ this.booking.dental_unit_code }}</td>
                    </tr>
                    </tbody>
                </table>

                <table id="tbl" style="margin-top: 20px; margin-bottom: 15px">
                    <thead>
                    <tr>
                        <th rowspan="2">No</th>
                        <th rowspan="2">Apsek yang Dinilai</th>
                        <th rowspan="2">Bobot</th>
                        <th colspan="4">Skor</th>
                        <th rowspan="2">Nilai</th>
                    </tr>
                    <tr>
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(r, index) in refPenilaian">
                        <td style="text-align: center">{{ index + 1 }}</td>
                        <td style="white-space: pre; font-weight: bold">{{ r.name }}</td>
                        <td style="text-align: center;">{{ r.weight }}</td>
                        <td style="text-align: center;min-width: 50px;"><input type="radio" v-model="selection[index]" :name="'rdb' + index + '[]'" value="25"/></td>
                        <td style="text-align: center;min-width: 50px;"><input type="radio" v-model="selection[index]" :name="'rdb' + index + '[]'" value="50"/></td>
                        <td style="text-align: center;min-width: 50px;"><input type="radio" v-model="selection[index]" :name="'rdb' + index + '[]'" value="75"/></td>
                        <td style="text-align: center;min-width: 50px;"><input type="radio" v-model="selection[index]" :name="'rdb' + index + '[]'" value="100"/></td>
                        <td style="min-width: 70px; text-align: center; font-weight: bold">{{ r.weight * (isNaN(parseInt(selection[index])) ? 0 : parseInt(selection[index])) / 100 }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td style="font-weight: bold; text-align: center">Jumlah</td>
                        <td style="text-align: center;">{{ this.refPenilaian.reduce((a, b) => a + parseInt(b.weight), 0) }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="min-width: 70px; font-size: 1.2em; text-align: center; font-weight: bold">{{ totalNilai() }}</td>
                    </tr>
                    </tbody>
                </table>

                <div style="text-align: center">
                    <a-button type="primary" @click="save()" style="min-width: 150px; font-size: 1.2em">Simpan</a-button>
                </div>
            </a-col>
        </a-row>
        <!-- / Charts -->
    </div>
</template>

<script>

import BookingApi from "../../../repository/api/BookingApi";
import {dateFormatIndoWithDay} from "../../../utils/Extenstion";
import PenilaianApi from "../../../repository/api/PenilaianApi";

export default {
    data() {
        return {
            data: [],
            booking: {},
            is_partner: false,
            selection: [],
        }
    },

    async mounted() {
        this.is_partner = this.$route.params.partner === 'true'

        await this.$store.dispatch("apiData/getRefPenilaian")

        this.getData()
    },

    methods: {
        getData() {
            BookingApi.get(this.$route.params.id)
                .then((response) => {
                    this.booking = response
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })

            PenilaianApi.get(this.$route.params.id, this.is_partner)
                .then(r => {
                    this.data = r
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })
        },

        save() {
            if (this.selection.length === 0 || this.selection.filter(x => isNaN(parseInt(x)) || parseInt(x) <= 0).length > 0) {
                this.$swal({
                    title: "Lengkapi",
                    text: "Mohon untuk melengkapi pilihan nilai",
                    confirmButtonText: "OK",
                    icon: "warning",
                })

                return
            }

            const data = []

            for (let a = 0; a < this.refPenilaian.length; a++) {
                data.push({
                    id: this.refPenilaian[a].id,
                    value: this.selection[a]
                })
            }

            // Kalau update penilaian
            if (this.data.length) {
                PenilaianApi.update(data)
                    .then(r => {
                        this.$swal({
                            title: "Sukses",
                            text: "Sukses mengubah penilaian",
                            confirmButtonText: "OK",
                            icon: "info",
                        })
                            .then(e => {
                                this.$router.push("/dashboards")
                            }, e => {
                                this.$router.push("/dashboards")
                            })
                    })
                    .catch((e) => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            }
            else {
                PenilaianApi.save(this.booking.id, data, this.is_partner)
                    .then(r => {
                        this.$swal({
                            title: "Sukses",
                            text: "Sukses menginputkan penilaian",
                            confirmButtonText: "OK",
                            icon: "info",
                        })
                            .then(e => {
                                this.$router.push("/dashboards")
                            }, e => {
                                this.$router.push("/dashboards")
                            })
                    })
                    .catch((e) => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            }
        },

        // Helper methods ==============
        formatDate(dateString) {
            return dateString ? dateFormatIndoWithDay(dateString) : ''
        },

        totalNilai() {
            let total = 0

            for (let a = 0; a < this.refPenilaian.length; a++) {
                total += parseInt(this.selection[a]) * parseInt(this.refPenilaian[a].weight)
            }

            if (isNaN(total))
                return 0
            else
                return total / 100
        }
    },

    computed: {
        refPenilaian() {
            if (this.data.length)
                return this.data.map(x => ({
                    ...x,
                    name: x.penilaian_txt,
                }))
            else
                return this.$store.getters['apiData/refPenilaian']
        },

        case() {
            if (!this.booking.case) return ''

            const c = this.booking.case.find(x => x.is_partner == this.is_partner)

            if (!c) return ''

            return c.name
        },
    },

    watch: {
        refPenilaian(n, o) {
            this.selection = n.map(x => x.percentage ? parseInt(x.percentage) : 0)
        }
    }
}
</script>

<style lang="scss" scoped>
$md: 768px;

.dashboard::v-deep {
    .globeContainer {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 15rem;
        margin-right: 6rem;
    }

    .ant-row-flex {
        position: relative;
        z-index: 1;

        @media (min-width: $md) {
            position: static;
        }
    }
}

.no-data {
    color: #2f7ab4;
    font-size: 18px;
    text-align: center;
}

#tbl {
    width: 100%;
    border-collapse: collapse;

    th, td {
        border: 1px solid;
        padding: 3px 10px;
    }

    th {
        text-align: center;
    }
}

</style>